export default __webpack_public_path__ + "275f26891ea0f1cde72c4e8ac1527b98.svg";